import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
export function AnimatedSection({
  children,
  className = "",
  delay = 0,
}) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [100, -100]);
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.9, 1], [0, 1, 1, 0]);

  return (
    <motion.div
      ref={ref}
      // style={{ y, opacity }}
      // initial={{ opacity: 0, y: 50 }}
      // whileInView={{ opacity: 1, y: 0 }}
      // viewport={{ once: true, margin: "-100px" }}
      // transition={{
      //   duration: 0.8,
      //   delay,
      //   ease: [0.25, 0.4, 0.25, 1],
      // }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
